export const PERIOD_OPTIONS = [
  {
    text: 'Hoje',
    value: 'getToday',
  },
  {
    text: 'Ontem',
    value: 'getYesterday',
  },
  {
    text: 'Essa semana',
    value: 'getThisWeek',
  },
  {
    text: 'Semana anterior',
    value: 'getLastWeek',
  },
  {
    text: 'Este mês',
    value: 'getThisMonth',
  },
  {
    text: 'Este trimestre',
    value: 'getThisQuarter',
  },
  {
    text: 'Último trimestre',
    value: 'getLastQuarter',
  },
  {
    text: 'Este ano',
    value: 'getThisYear',
  },
  {
    text: 'Ano anterior',
    value: 'getLastYear',
  },
  {
    text: 'Intervalo de datas',
    value: 'custom',
  },
];

export const PERIOD_OPTIONS_MONTHS = [
  {
    text: 'Janeiro',
    value: 0,
  },
  {
    text: 'Fevereiro',
    value: 1,
  },
  {
    text: 'Março',
    value: 2,
  },
  {
    text: 'Abril',
    value: 3,
  },
  {
    text: 'Maio',
    value: 4,
  },
  {
    text: 'Junho',
    value: 5,
  },
  {
    text: 'Julho',
    value: 6,
  },
  {
    text: 'Agosto',
    value: 7,
  },
  {
    text: 'Setembro',
    value: 8,
  },
  {
    text: 'Outubro',
    value: 9,
  },
  {
    text: 'Novembro',
    value: 10,
  },
  {
    text: 'Dezembro',
    value: 11,
  },
];

export const BREADCRUMB_PATHS = [
  {
    type: 'link',
    text: 'Minha conta',
    href: '/account',
  },
  {
    text: 'Acompanhamento de progresso',
  },
];

export const HIERARCHY_MAP_VALUE = {
  board: 0,
  school: 1,
  coordination: 2,
  faculty: 3,
  class: 4,
};

export const HIERARCHY_MAP_VALUES = {
  0: {
    tableHeader: 'Diretoria',
  },
  1: {
    tableHeader: 'Escola',
  },
  2: {
    tableHeader: 'Coordenação',
  },
  3: {
    tableHeader: 'Corpo docente',
  },
  4: {
    tableHeader: 'Turma',
  },
  5: {
    tableHeader: 'Aluno',
  },
};

export const DELETED_BY_CHIP = 0;

export const FILTER_OPTIONS = [
  {
    id: 417,
    name: 'Diretoria 1',
    children: [
      {
        id: 822,
        name: 'Escola 1',
        children: [
          {
            id: 228,
            name: 'Coordenação 1',
            children: [
              {
                id: 798,
                name: 'Corpo Docente 1',
                children: [
                  {
                    id: 854,
                    name: 'Turma 1',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 218,
    name: 'Diretoria 2',
    children: [
      {
        id: 348,
        name: 'Escola 2',
        children: [
          {
            id: 737,
            name: 'Coordenação 2',
            children: [
              {
                id: 576,
                name: 'Corpo Docente 2',
                children: [
                  {
                    id: 94,
                    name: 'Turma 2',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 505,
    name: 'Diretoria 3',
    children: [
      {
        id: 247,
        name: 'Escola 3',
        children: [
          {
            id: 765,
            name: 'Coordenação 3',
            children: [
              {
                id: 427,
                name: 'Corpo Docente 3',
                children: [
                  {
                    id: 478,
                    name: 'Turma 3',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 758,
    name: 'Diretoria 4',
    children: [
      {
        id: 684,
        name: 'Escola 4',
        children: [
          {
            id: 939,
            name: 'Coordenação 4',
            children: [
              {
                id: 12,
                name: 'Corpo Docente 4',
                children: [
                  {
                    id: 567,
                    name: 'Turma 4',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 777,
    name: 'Diretoria 5',
    children: [
      {
        id: 898,
        name: 'Escola 5',
        children: [
          {
            id: 27,
            name: 'Coordenação 5',
            children: [
              {
                id: 321,
                name: 'Corpo Docente 5',
                children: [
                  {
                    id: 123,
                    name: 'Turma 5',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const TABLE_HEADERS = [
  {
    field: 'label',
    headerName: 'Grupo',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 158,
  },
  {
    field: 'engagement',
    headerName: 'Estudantes',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 158,
  },
  {
    field: 'averageGrade',
    headerName: 'Nota média',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 128,
  },
  {
    field: 'studyTime',
    headerName: 'Tempo de estudo',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 158,
  },
  {
    field: 'concluded',
    headerName: 'Unidades concluídas',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 158,
  },
  {
    field: 'privateTalks',
    headerName: 'Aulas Particulares',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 158,
  },
  {
    field: 'groupTalks',
    headerName: 'Conversação',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 158,
  },
  {
    field: 'averagePlatformScore',
    headerName: 'Score',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 60,
  },
];

export const STUDENTS_TABLE_HEADERS = [
  {
    field: 'averageGrade',
    headerName: 'Nota média',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 120,
  },
  {
    field: 'studyTime',
    headerName: 'Tempo de estudo',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 164,
  },
  {
    field: 'concluded',
    headerName: 'Unidades concluídas',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 164,
  },
  {
    field: 'privateTalks',
    headerName: 'Aulas Particulares',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 164,
  },
  {
    field: 'groupTalks',
    headerName: 'Conversação',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 164,
  },
  {
    field: 'platformScore',
    headerName: 'Score',
    sortable: false,
    editable: false,
    disableColumnMenu: true,
    minWidth: 60,
  },
];

export const ROWS_MOCK = {
  summary: {
    engagement: {
      current: 400,
      total: 1000,
    },
    averageGrade: {
      current: 3.8,
      max: 5,
    },
    studyTime: '00:58:00',
    concluded: 1787,
    privateTalks: 245,
    groupTalks: 1337,
  },
  items: [
    {
      id: 0,
      label: 'Word383',
      engagement: 921,
      averageGrade: 0.26,
      studyTime: '19:20:34',
      concluded: 1384,
      privateTalks: 209,
      groupTalks: 1488,
    },
    {
      id: 1,
      label: 'Word668',
      engagement: 117,
      averageGrade: 0.35,
      studyTime: '82:11:11',
      concluded: 1447,
      privateTalks: 716,
      groupTalks: 1206,
    },
    {
      id: 2,
      label: 'Word339',
      engagement: 361,
      averageGrade: 0.5,
      studyTime: '54:18:49',
      concluded: 411,
      privateTalks: 84,
      groupTalks: 509,
    },
    {
      id: 3,
      label: 'Word35',
      engagement: 906,
      averageGrade: 0.37,
      studyTime: '24:12:51',
      concluded: 1657,
      privateTalks: 532,
      groupTalks: 905,
    },
    {
      id: 4,
      label: 'Word42',
      engagement: 252,
      averageGrade: 0.5,
      studyTime: '77:46:31',
      concluded: 996,
      privateTalks: 226,
      groupTalks: 1670,
    },
    {
      id: 5,
      label: 'Word686',
      engagement: 121,
      averageGrade: 0.29,
      studyTime: '09:46:27',
      concluded: 1187,
      privateTalks: 852,
      groupTalks: 1132,
    },
    {
      id: 6,
      label: 'Word977',
      engagement: 351,
      averageGrade: 0.5,
      studyTime: '30:01:02',
      concluded: 359,
      privateTalks: 409,
      groupTalks: 1157,
    },
    {
      id: 7,
      label: 'Word242',
      engagement: 943,
      averageGrade: 0.48,
      studyTime: '94:43:34',
      concluded: 1304,
      privateTalks: 1,
      groupTalks: 1392,
    },
    {
      id: 8,
      label: 'Word843',
      engagement: 622,
      averageGrade: 0.01,
      studyTime: '66:09:14',
      concluded: 1471,
      privateTalks: 438,
      groupTalks: 952,
    },
    {
      id: 9,
      label: 'Word237',
      engagement: 64,
      averageGrade: 0.04,
      studyTime: '39:43:12',
      concluded: 1635,
      privateTalks: 207,
      groupTalks: 1996,
    },
    {
      id: 10,
      label: 'Word843',
      engagement: 622,
      averageGrade: 0.01,
      studyTime: '66:09:14',
      concluded: 1471,
      privateTalks: 438,
      groupTalks: 952,
    },
    {
      id: 11,
      label: 'Word237',
      engagement: 64,
      averageGrade: 0.04,
      studyTime: '39:43:12',
      concluded: 1635,
      privateTalks: 207,
      groupTalks: 1996,
    },
    {
      id: 12,
      label: 'Word843',
      engagement: 622,
      averageGrade: 0.01,
      studyTime: '66:09:14',
      concluded: 1471,
      privateTalks: 438,
      groupTalks: 952,
    },
    {
      id: 13,
      label: 'Word237',
      engagement: 64,
      averageGrade: 0.04,
      studyTime: '39:43:12',
      concluded: 1635,
      privateTalks: 207,
      groupTalks: 1996,
    },
    {
      id: 14,
      label: 'Word843',
      engagement: 622,
      averageGrade: 0.01,
      studyTime: '66:09:14',
      concluded: 1471,
      privateTalks: 438,
      groupTalks: 952,
    },
    {
      id: 15,
      label: 'Word237',
      engagement: 64,
      averageGrade: 0.04,
      studyTime: '39:43:12',
      concluded: 1635,
      privateTalks: 207,
      groupTalks: 1996,
    },
  ],
  pageSize: 20,
  currentPage: 1,
  totalItems: 10,
};

export const STUDENTS_MOCK = {
  summary: {
    engagement: {
      current: 400,
      total: 1000,
    },
    averageGrade: {
      current: 3.8,
      max: 5,
    },
    studyTime: '00:58:00',
    concluded: 1787,
    privateTalks: 245,
    groupTalks: 1337,
  },
  items: [
    {
      id: 0,
      description: 'John383',
      averageGrade: 0.26,
      studyTime: '19:20:34',
      concluded: 1384,
      privateTalks: 209,
      groupTalks: 1488,
    },
    {
      id: 1,
      description: 'John668',
      averageGrade: 0.35,
      studyTime: '82:11:11',
      concluded: 1447,
      privateTalks: 716,
      groupTalks: 1206,
    },
    {
      id: 2,
      description: 'John339',
      averageGrade: 0.5,
      studyTime: '54:18:49',
      concluded: 411,
      privateTalks: 84,
      groupTalks: 509,
    },
    {
      id: 3,
      description: 'John35',
      averageGrade: 0.37,
      studyTime: '24:12:51',
      concluded: 1657,
      privateTalks: 532,
      groupTalks: 905,
    },
    {
      id: 4,
      description: 'John42',
      averageGrade: 0.5,
      studyTime: '77:46:31',
      concluded: 996,
      privateTalks: 226,
      groupTalks: 1670,
    },
    {
      id: 5,
      description: 'John686',
      averageGrade: 0.29,
      studyTime: '09:46:27',
      concluded: 1187,
      privateTalks: 852,
      groupTalks: 1132,
    },
    {
      id: 6,
      description: 'John977',
      averageGrade: 0.5,
      studyTime: '30:01:02',
      concluded: 359,
      privateTalks: 409,
      groupTalks: 1157,
    },
    {
      id: 7,
      description: 'John242',
      averageGrade: 0.48,
      studyTime: '94:43:34',
      concluded: 1304,
      privateTalks: 1,
      groupTalks: 1392,
    },
    {
      id: 8,
      description: 'John843',
      averageGrade: 0.01,
      studyTime: '66:09:14',
      concluded: 1471,
      privateTalks: 438,
      groupTalks: 952,
    },
    {
      id: 9,
      description: 'John237',
      averageGrade: 0.04,
      studyTime: '39:43:12',
      concluded: 1635,
      privateTalks: 207,
      groupTalks: 1996,
    },
  ],
  pageSize: 20,
  currentPage: 1,
  totalItems: 10,
};

export const STUDENT_PROGRESS_HEAD_CELLS = [
  'Tipo',
  'Data',
  'Horário',
  'Tema',
  'Professor',
  'Nível',
];

export const STUDENT_PROGRESS_ROWS_CELLS = [
  {
    type: 'privateTalk',
    date: '2022-11-19',
    time: '9h00 - 9h25',
    theme: 'Learning',
    talker: 'John',
    level: 'A1',
  },
  {
    type: 'groupTalk',
    date: '2022-11-20',
    time: '10h30 - 11h00',
    theme: 'Programming',
    talker: 'Alice',
    level: 'A1',
  },
  {
    type: 'privateTalk',
    date: '2022-11-21',
    time: '14h15 - 14h45',
    theme: 'Cooking',
    talker: 'Sarah',
    level: 'A1',
  },
  {
    type: 'groupTalk',
    date: '2022-11-22',
    time: '16h00 - 16h30',
    theme: 'Music',
    talker: 'David',
    level: 'A1',
  },
  {
    type: 'privateTalk',
    date: '2022-11-23',
    time: '19h30 - 20h00',
    theme: 'Travel',
    talker: 'Emily',
    level: 'A1',
  },
  {
    type: 'groupTalk',
    date: '2022-11-24',
    time: '11h45 - 12h15',
    theme: 'Sports',
    talker: 'Michael',
    level: 'A1',
  },
  {
    type: 'privateTalk',
    date: '2022-11-25',
    time: '15h30 - 16h00',
    theme: 'Art',
    talker: 'Olivia',
    level: 'A1',
  },
  {
    type: 'groupTalk',
    date: '2022-11-26',
    time: '17h45 - 18h15',
    theme: 'Science',
    talker: 'Daniel',
    level: 'A1',
  },
  {
    type: 'privateTalk',
    date: '2022-11-27',
    time: '13h00 - 13h30',
    theme: 'History',
    talker: 'Sophia',
    level: 'A1',
  },
  {
    type: 'groupTalk',
    date: '2022-11-28',
    time: '20h15 - 20h45',
    theme: 'Technology',
    talker: 'Liam',
    level: 'A1',
  },
];

export const LEVEL_OPTIONS = [
  {
    text: 'Beginner',
    value: 'a1',
  },
  {
    text: 'Basic',
    value: 'a2',
  },
  {
    text: 'Intermediate',
    value: 'b1',
  },
  {
    text: 'Upper-Intermediate',
    value: 'b2',
  },
  {
    text: 'Advanced',
    value: 'c1',
  },
];

export const THEORY_PROGRESS_HEAD_CELLS = [
  'Seção',
  'Progresso',
  'Tempo gasto',
  'Nota média',
  'Reforço',
];

export const THEORY_PROGRESS_SUB_HEAD_CELLS = [
  'Atividade',
  'Tipo',
  'Status',
  'Tempo',
  'Nota',
];

export const THEORY_PROGRESS_SUB_HEAD_CELLS_QUIZ = [
  ...THEORY_PROGRESS_SUB_HEAD_CELLS,
  'Respostas',
];

export const THEORY_TABLE_DATA = [
  {
    section: 'Intermediate',
    progress: 100,
    timeSpent: '10:11:35',
    averageGrade: '4.3',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'incompleted',
        timeSpent: '08:05:41',
        grade: '1.2',
        type: 'video',
      },
    ],
  },
  {
    section: 'Intermediate',
    progress: 100,
    timeSpent: '10:44:13',
    averageGrade: '1.9',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'completed',
        timeSpent: '12:28:42',
        grade: '3.7',
        type: 'flashCards',
      },
    ],
  },
  {
    section: 'Getting Started',
    progress: 100,
    timeSpent: '16:36:04',
    averageGrade: '4.7',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'completed',
        timeSpent: '04:23:28',
        grade: '3.3',
        type: 'video',
      },
    ],
  },
  {
    section: 'Advanced',
    progress: 100,
    timeSpent: '12:23:15',
    averageGrade: '4.5',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'completed',
        timeSpent: '14:31:38',
        grade: '3.7',
        type: 'test',
      },
    ],
  },
  {
    section: 'Getting Started',
    progress: 100,
    timeSpent: '13:49:46',
    averageGrade: '2.3',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'completed',
        timeSpent: '21:53:58',
        grade: '1.0',
        type: 'test',
      },
    ],
  },
  {
    section: 'Intermediate',
    progress: 100,
    timeSpent: '18:36:18',
    averageGrade: '3.5',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'notInitiated',
        timeSpent: '16:15:51',
        grade: '4.5',
        type: 'test',
      },
    ],
  },
  {
    section: 'Advanced',
    progress: 100,
    timeSpent: '11:00:14',
    averageGrade: '2.0',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'incompleted',
        timeSpent: '21:32:29',
        grade: '3.7',
        type: 'video',
      },
    ],
  },
  {
    section: 'Welcome to beginner',
    progress: 100,
    timeSpent: '04:48:50',
    averageGrade: '2.5',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'notInitiated',
        timeSpent: '13:39:10',
        grade: '3.9',
        type: 'test',
      },
    ],
  },
  {
    section: 'Getting Started',
    progress: 100,
    timeSpent: '18:15:19',
    averageGrade: '4.5',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'notInitiated',
        timeSpent: '01:17:59',
        grade: '4.1',
        type: 'flashCards',
      },
    ],
  },
  {
    section: 'Intermediate',
    progress: 100,
    timeSpent: '19:20:21',
    averageGrade: '2.5',
    activities: [
      {
        activity: 'Welcome to class',
        status: 'incompleted',
        timeSpent: '18:10:45',
        grade: '3.1',
        type: 'test',
      },
    ],
  },
];
